var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingNotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 31.9785L34.375 39.7493L30.9583 25.1035L42.3333 15.2493L27.3542 13.9785L21.5 0.166016L15.6458 13.9785L0.666667 15.2493L12.0417 25.1035L8.625 39.7493L21.5 31.9785Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingNotSelected);
export default __webpack_public_path__ + "static/media/rating_not_selected.cacd548fccee83dc8a116e4cd4f740ba.svg";
export { ForwardRef as ReactComponent };